import { useMemo } from 'react';
import { getDomainBranding } from '../tenant/tenantConfig.js';

/**
 * Returns resolved branding for the current tenant.
 * Priority: state.branding.companyName (set by tenant admin in Settings → Branding)
 *         → tenant.branding.companyName (set by super-admin in registry)
 *         → getDomainBranding().name (domain-derived fallback, e.g. "Tryggr")
 */
export function useBranding(state, tenant = null) {
  return useMemo(() => {
    const domain = getDomainBranding();
    const saved = state?.branding || {};
    const registryName = tenant?.branding?.companyName?.trim();
    return {
      ...domain,
      name: saved.companyName?.trim() || registryName || domain.name,
      logoImage: saved.logoImage || tenant?.branding?.logoImage || '',
      zoom: saved.zoom ?? 1,
      panX: saved.panX ?? 0,
      panY: saved.panY ?? 0,
    };
  }, [
    state?.branding?.companyName,
    state?.branding?.logoImage,
    state?.branding?.zoom,
    state?.branding?.panX,
    state?.branding?.panY,
    tenant?.branding?.companyName,
    tenant?.branding?.logoImage,
  ]);
}
